<template>
<div class="col-xs-12">
  <div class="card float-e-margins">
    <div class="card-title">
        <h1>Reacties goedkeuren</h1>
    </div>
    <div class="card-content no-padding">
      <vc-alert v-if="success" type="success"
         :timeout="4000">
      {{successMessage}}
      </vc-alert>
      <vc-alert v-if="error" type="danger" :dismissible="false">
         Er is een fout opgetreden!
      </vc-alert>
      <div class="table-responsive">
        <div class="card-title card-header form-horizontal">
          <label>Aantal reacties: {{total}} </label>
          <div class="form-group">
            <label class="control-label col-sm-1" style="text-align:left;" for="filter">Filter op : </label>
            <div class="col-sm-4">
              <input type="text" class="form-control" id="filter" placeholder="Filter" v-model="filterKey">
            </div>
          </div>
        </div>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th v-for="(key, val) in columns">
                <a @click="sortBy(val)" class="arrow" :class="active: sortKey == column">
                  {{ key | capitalize }}
                </a>
              </th>
          </thead>
          <tbody>
            <tr v-for="review in Reviews | filterBy filterKey | orderBy sortKey reverse">
              <td>
                <input v-if="edit" type="text" class="form-control" id="reviewDesc" v-model="review.Type">
                <p v-else style="white-space:pre-line;"><small>{{ review.Name }}</small></p>
              </td>
              <td>
                <input v-if="edit" type="text" class="form-control" id="reviewDesc" v-model="review.Description">
                <p v-else style="white-space:pre-line;"><small>{{ review.Content }}</small></p>
              </td>
              <td>
                <div class="ios">
                  <vui-toggle name="wifi" :checked.sync="review.Approved" @change="setAvailable(review)"></vui-toggle>
                </div>
                <p v-if="review.Approved" class="text-success">Aan</p>
                <p v-else class="text-danger">Verborgen</p>
              </td>
              <td width="10%">
                <button type="button" class="btn btn-danger" @click="selectreview(review)">Verwijder</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<vm-delete :callback.sync="remove" :show.sync="showdeltemodal"></vm-delete>
</template>
<script>
import store from '../../store'
import callbackalert from '../Common/CallbackAlert'
import toggle from '../Common/Toggle'
import deletemodal from '../Common/deleteSweetAlert'
import modal from '../Common/Modal'
export default {
  route: {
    canReuse: false
  },
  components: {
    'vc-alert': callbackalert,
    'vui-toggle': toggle,
    'vm-delete': deletemodal,
    'v-modal': modal
  },
  data () {
    return {
      store: store,
      Reviews: {},
      success: false,
      error: false,
      successMessage: 'review succesvol bijgewerkt!',
      columns: {
        'Naam': 'Type',
        'Omschrijving': 'Description',
        'Status': 'Enabled',
        ' ': 'Actions'
      },
      sortKey: '',
      reverse: 1,
      showdeltemodal: false,
      selectedreview: null,
      filterKey: '',
      showCustomModal: false,
      edit: false
    }
  },
  created () {
    this.getReviews()
  },
  methods: {
    getReviews: function () {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/reviews/GetAll',
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          this.Reviews = response
        }.bind(this)
      })
    },
    remove: function () {
      console.log('Verwijderd~!')
      $.ajax({
        type: 'DELETE',
        url: store.root + 'api/reviews/' + this.selectedreview.ReviewId,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        this.error = false
        this.Reviews.$remove(this.selectedreview)
        this.selectedreview = null
        this.showdeltemodal = false
        console.log('Verwijderd~!')
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.success = false
        this.error = true
      }.bind(this))
    },
    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? this.reverse * -1 : -1
      this.sortKey = sortKey
    },
    setAvailable: function (item) {
      $.ajax({
        type: 'PUT',
        url: store.root + 'api/reviews/' + item.ReviewId,
        data: item,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        console.log('change Available succesfully done!')
      })
      .fail(function (response) {
        console.log(response)
      })
    },
    selectreview: function (val) {
      this.selectedreview = val
      this.showdeltemodal = true
    },
    save: function () {
      $.ajax({
        type: 'POST',
        url: store.root + 'api/Reviews',
        data: this.newreview,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.modalsuccess = true
        this.modalerror = false
        setTimeout(function () { location.reload(true) }, 2000)
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.modalsuccess = false
        this.modalerror = true
      }.bind(this))
    },
    updatereview: function (item) {
      $.ajax({
        type: 'PUT',
        url: store.root + 'api/Reviews/' + item.ConfigId,
        data: item,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        this.error = false
        this.edit = false
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.error = true
        this.success = false
      }.bind(this))
    }
  },
  computed: {
    total: function () {
      return this.Reviews.length
    }
  }
}
</script>


// WEBPACK FOOTER //
// guestbook.vue?fe11c460